import { render, staticRenderFns } from "./PaymentProviders.vue?vue&type=template&id=6b58eecf&"
import script from "./PaymentProviders.vue?vue&type=script&lang=js&"
export * from "./PaymentProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports